export default __webpack_public_path__ + "static/media/Coastal_200626_112714.cafbab0a.mp4";